<template>
  <div>
    <Header></Header>
    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <AdminSidebar></AdminSidebar>
        </div>
        <div class="col-md-9 col-sm-12 mb-3">
          <h4 class="mb-4">Order Approval</h4>
          <div class="w-100">
            <b-table
              :fields="fields"
              :items="orderItems"
              striped
              ref="selectableTable"
              selectable
              select-mode="multi"
              outlined
              @row-selected="onRowSelected"
              class="table table-responsive"
              responsive="sm"
              sort-icon-left
              :busy="isBusy"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(name)="data">{{
                data.item.firstname + " " + data.item.lastname
              }}</template>
              <template v-slot:cell(date_created)="data">{{
                moment(data.item.date_created).format("MM/DD/YYYY")
              }}</template>
              <template #head(select)>
                <b-form-checkbox @change="selectAllRows($event)"
                  >select</b-form-checkbox
                >
              </template>
              <template #cell(select)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @change="pageChange"
              align="right"
            ></b-pagination>
          </div>
          <button
            class="btn btn-primary m-2"
            v-on:click="approveSelectedOrders()"
          >
            Process selected Orders
          </button>
          <button
            class="btn btn-primary m-2"
            v-on:click="rejectSelectedOrders()"
          >
            Delete selected Orders
          </button>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";

export default {
  name: "OrderApproval",
  data() {
    return {
      fields: [
        {
          key: "username",
          label: "User",
          sortable: true,
        },
        {
          key: "name",
          label: "Recipient",
          sortable: true,
        },
        {
          key: "product_title",
          label: "Product",
          sortable: true,
        },
        {
          key: "date_created",
          label: "Submitted",
          sortable: true,
        },
        {
          key: "gift",
          sortable: true,
        },
        {
          key: "user_unit_final_cost",
          label: "Points",
          sortable: false,
        },
        {
          key: "points",
          label: "Pnts. Available",
          sortable: true,
        },
        {
          key: "select",
          class: "text-center",
        },
      ],
      currentPage: 1,
      selectedItems: [],
      searchUserOrderId: "",
      sortField: "",
      sortOrder: "",
      perPage: 20,
      isBusy:false,
    };
  },
  components: {
    AdminSidebar,
    Header,
    Footer,
  },

  computed: {
    ...mapState({
      orderItems: (state) => state.orders.items.Result,
      totalRows: (state) => state.orders.items.totalRecords,
    }),
  },
  methods: {
    async fetchAllPendingOrders(
      searchUserOrderId,
      sortField,
      sortOrder,
      currentPage,
      perPage
    ) {
      this.isBusy=true;
      await this.$store.dispatch("orders/fetchAllPendingOrders", {
        searchUserOrderId: searchUserOrderId,
        sortField: sortField,
        sortOrder: sortOrder,
        pageNumber: currentPage,
        pageSize: perPage,
      });
      this.isBusy=false;
    },
    selectAllRows(checked) {
      if (checked) {
        this.$refs.selectableTable.selectAllRows();
      } else {
        this.$refs.selectableTable.clearSelected();
      }
    },
    pageChange(page) {
      this.currentPage = page;
      this.fetchAllPendingOrders(
        this.searchUserOrderId,
        this.sortField,
        this.sortOrder,
        this.currentPage,
        this.perPage
      );
    },
    onRowSelected(item) {
      this.selectedItems = [];
      item.forEach((data) => {
        this.selectedItems.push({
          order_id: data.order_id,
          cart_id: data.cart_id,
          user_id: data.user_id,
          client_id: data.client_id,
          product_id: data.product_id,
        });
      });
      console.log(this.selectedItems);
    },
    async rejectSelectedOrders() {
    await this.$store.dispatch("orders/removeOrders", this.selectedItems);
      this.fetchAllPendingOrders(
        this.searchUserOrderId,
        this.sortField,
        this.sortOrder,
        this.currentPage,
        this.perPage
      );
    },
    async approveSelectedOrders() {
      await this.$store.dispatch("orders/approveOrders", this.selectedItems);
      this.fetchAllPendingOrders(
        this.searchUserOrderId,
        this.sortField,
        this.sortOrder,
        this.currentPage,
        this.perPage
      );
    },
  },

  created() {
    this.fetchAllPendingOrders(
      this.searchUserOrderId,
      this.sortField,
      this.sortOrder,
      this.currentPage,
      this.perPage
    );
  },
};
</script>

<style lang="scss" scoped></style>
